// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-3_wvl"};